import joi from 'joi';

import { emailSchema } from '@src/schemas/email.schema';

import { Overview } from './types';

export const overviewSchema = joi.object<Overview>({
  email: emailSchema.required(),
});
